import { useTranslation } from 'react-i18next'
import contentData from '../data/content.json'
import Button from '../components/ui/Button'

function TCTSY() {
  const { t } = useTranslation()

  return (
    <div className="w-full">
      {/* What is TCTSY */}
      <section className="section-container bg-white py-60 px-60">
        <div className="content-wrapper">
          <h2 className="text-lato-regular mb-20">
            {t('pages.tctsy.sections.whatIs.heading')}
          </h2>
          <p className="text-lato-regular">
            {t('pages.tctsy.sections.whatIs.text')}
          </p>
        </div>
      </section>

      {/* Research & Evidence */}
      <section className="section-container bg-white py-60 px-60">
        <div className="content-wrapper">
          <h2 className="text-lato-regular mb-20">
            {t('pages.tctsy.sections.research.heading')}
          </h2>
          <p className="text-lato-regular">
            {t('pages.tctsy.sections.research.text')}
          </p>
          <a
            href={t('pages.tctsy.sections.research.link')}
            target="_blank"
            rel="noopener noreferrer"
            className="text-black underline hover:opacity-70"
          >
            {t('pages.tctsy.sections.research.link')}
          </a>
        </div>
      </section>

      {/* How TCTSY is Different */}
      <section className="section-container bg-white py-60 px-60">
        <div className="content-wrapper">
          <h2 className="text-lato-regular mb-20">
            {t('pages.tctsy.sections.different.heading')}
          </h2>

          {t('pages.tctsy.sections.different.sections', { returnObjects: true }).map((section, index) => (
            <div key={index} className="mb-40">
              {index === 1 && section.image && (
                <div className="flex flex-col tablet:flex-row gap-24 items-start">
                  <div className="flex-1">
                    <h3 className="text-lato-regular mb-12">{section.title}</h3>
                    <p className="text-lato-regular">{section.text}</p>
                  </div>
                  <div className="flex-1">
                    <img
                      src={contentData.images.tctsyPractice.url}
                      alt={contentData.images.tctsyPractice.alt}
                      className="w-full h-auto object-cover rounded-md"
                    />
                  </div>
                </div>
              )}
              {(!section.image || index !== 1) && (
                <>
                  <h3 className="text-lato-regular mb-12">{section.title}</h3>
                  <p className="text-lato-regular">{section.text}</p>
                </>
              )}
            </div>
          ))}
        </div>
      </section>
    </div>
  )
}

export default TCTSY
